/**
 * @module ProductLegends
 */
import { loadHtml } from './utils/loadUtils.js';
import { stringTemplateParser } from './utils/stringTemplateParser.js';
import { t } from './utils/i18n.js';

class ProductLegends {
  constructor(map) {
    this.map = map;
    this.mapDiv = document.getElementById("map");
  }

  async addLegends(config) {
    const legendsConfig = config.legends;
    for (const legendConfig of legendsConfig) {
      let legendHtml = await loadHtml(t(legendConfig.urlKey));
      // If the config has a metadata section, replace template variables
      // in the legend HTML with metadata values.
      if (config.metadata && Object.keys(config.metadata).length > 0) {
        legendHtml = stringTemplateParser(legendHtml, config.metadata);
      }
      const legendElement = document.createElement('div');
      legendElement.id = legendConfig.id;
      legendElement.innerHTML = legendHtml;
      if (legendConfig.target === 'map') {
        this.mapDiv.appendChild(legendElement);
      }
      else {
        const targetElement = document.getElementById(legendConfig.target);
        targetElement.appendChild(legendElement);
      }
    }
  }

  removeLegends(config) {
    const legendsConfig = config.legends;
    legendsConfig.forEach(legendConfig => {
      const legendElement = document.getElementById(legendConfig.id);
      if (legendElement) {
        legendElement.remove();
      }
    });
  }
}

export default ProductLegends;